import {ProjectTypes} from './project-types.enum';

export enum AppointmentProjectTypes {
  GEO_ADVANCED = ProjectTypes.GEO_ADVANCED,
  GEO_ADVANCED_WIDGET = ProjectTypes.GEO_ADVANCED_WIDGET,
  WTG_ADVANCED = ProjectTypes.WTG_ADVANCED,
  WTG_ADVANCED_WIDGET = ProjectTypes.WTG_ADVANCED_WIDGET
}
